import type { Client, RequestContext } from "../client";
import type { MaintenanceConfigurationResource } from "../resources";
import { ConfigurationRepository } from "./configurationRepository";
export class MaintenanceConfigurationRepository extends ConfigurationRepository<MaintenanceConfigurationResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("MaintenanceConfiguration", client, requestContext);
    }
}
